<template>
	<view @click="click(data.config.path)" style="overflow: hidden; padding: 10px;"
		:style="{'background':data.config.containerBgColor ||'','border-radius':data.config.borderRadius+'px','color':data.config.textColor ||'','marginTop': data.config.marginTop+'px','marginRight': data.config.marginRight+'px', 'marginBottom': data.config.marginBottom+'px','marginLeft': data.config.marginLeft+'px','paddingTop': data.config.paddingTop+'px','paddingBottom': data.config.paddingBottom+'px','paddingLeft': data.config.paddingLeft+'px','paddingRight': data.config.paddingRight+'px'}">


		<view
			style="display:flex;height:80rpx;align-items:center;justify-content: center;padding-left:30rpx; padding-right:30rpx;"
			>
			<view style="font-size:18px;flex:1">我的资产</view>
			<view style="font-size:14px; color: darkgray;" class="t-box">查看明细
				<uni-icons type="right" size="16"></uni-icons>
			</view>
		</view>

		<view style="margin-top: 20px;" class="groupCat_item_container"
			:style="{ background: data.config.containerBgColor, color: data.config.textColor }">
			<view class="small_menuItem_view" @click="toToken">
				<view style="display: flex; align-items: center; font-size: 24px;">
					{{asset.token || '0'}}
				</view>
				<view style="display: flex;"> <text style="font-size: 14px; color: darkgray;" class="menuItem-label"
						:style="{ color: data.config.textColor }">我的算力</text> </view>

			</view>

			<view class="small_menuItem_view" @click="toAvatar">
				<view style="display: flex; align-items: center; font-size: 24px;">
					{{asset.avatar || '0'}}
				</view>
				<view style="display: flex;"> <text style="font-size: 14px; color: darkgray;" class="menuItem-label"
						:style="{ color: data.config.textColor }">数字人</text></view>

			</view>

			<view class="small_menuItem_view" @click="toAudio">
				<view style="display: flex; align-items: center; font-size: 24px;">
					{{asset.audio || '0'}}
				</view>
				<view style="display: flex;"> <text style="font-size: 14px; color: darkgray;" class="menuItem-label"
						:style="{ color: data.config.textColor }">声音克隆</text> </view>

			</view>
		</view>


	</view>
</template>

<script>
	export default {
		name: 'Tpl_Ai_Asset',
		props: {
			data: {
				type: Object,
				default: () => ({})
			},
			order: {
				type: Array,
				default: () => []
			},
		},
		data() {
			return {
				asset: {}
			}
		},
		mounted() {
			this.getAiAsset()
		},
		methods: {
			toToken() {
				uni.navigateTo({
					url: '/pages/index/index'
				});
			},
			
			toAvatar() {
				uni.navigateTo({
					url: '/pages/aigc/avatar_create'
				});
			},
			
			toAudio() {
				uni.navigateTo({
					url: '/pages/aigc/voice_clone'
				});
			},


			getAiAsset() {
				let t = this;
				t.$get({
					context: t,
					path: '/user/ai/asset/',
					params: {},
					success: function(data) {
						console.log(data)
						t.asset = data
					}
				})
			},
		}
	};
</script>

<style scoped>
	.t-box {
		display: flex;
		align-items: center;
	}

	.groupCat_item_container {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		padding: 5px;
	}

	.small_menuItem_view {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 2px;
		padding: 2px;
	}

	.menuItem-label {
		font-size: 16px;
		margin-top: 2px;
	}
</style>